import React, { useEffect } from 'react';
import { navigate } from 'gatsby';
import { globalHistory } from '@gatsbyjs/reach-router';
import ProgressBar from './progress-bar/progress-bar';
import { EnrollmentLayout } from '../../../../hoc/components/layout/enrollment-layout';
import { FlowRouteProps } from '../../../flow/flow';
import Section from '../../../../hoc/components/section/section';
import useTranslation from '../../../../../hooks/useTranslation';

function Waiting({location}: FlowRouteProps) {
	const { t } = useTranslation();

	useEffect(() => {
		return globalHistory.listen(({ action }) => {
			if (action === 'POP') {
				navigate(location?.pathname!);
			}
		});
	}, [location]);

	return (
		<EnrollmentLayout
			label={t('pages.waiting.label')}
			isBackButton={false}
			mlrVersion={t('pages.waiting.mlrVersion')}
			title={t('pages.waiting.header')}>
			<Section
				width='max-w-4xl'
				description={t('pages.waiting.description')}
				descriptionClassName='text-lg text-left lg:text-center'>
				<div data-testid="waiting-component" className="w-80 lg:w-96">
					<ProgressBar />
				</div>
			</Section>
		</EnrollmentLayout>
	);
}

export default Waiting;
